module.exports = function () {
    $(document).ready(function () {

        var tickbox = $('#still_in_employment');
        var date_end = $('#date_end');

        /** First check */
        if (tickbox.val() == '1') {
            date_end.val('');
            $("label[for='date_end']").removeClass('label-required');
            date_end.attr('required', false);
        }

        /** Then on each change */
        tickbox.on('change', function () {
            if ($(this).val() == '1') {
                date_end.val('');
                $("label[for='date_end']").removeClass('label-required');
                date_end.attr('required', false);
            } else {
                $("label[for='date_end']").addClass('label-required');
                date_end.attr('required', true);
            }
        });

    });
}();